import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/piotroski-f-score-calculator',
  component: () => import('../../routes/PiotroskiFScoreCalculator.svelte'),
  card: {
    id: 'piotroski-f-score-calculator',
    title: 'Piotroski F-Score Calculator',
    description:
      'Evaluate a company\'s financial strength using Joseph Piotroski\'s 9-criteria scoring system across profitability, leverage, and efficiency.',
    icon: 'verified',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/piotroski-f-score-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Piotroski F-Score Calculator — Value Investing Financial Health Check',
    description:
      'Calculate the Piotroski F-Score (0-9) to assess a company\'s financial strength. Nine binary criteria evaluate profitability, leverage, and operational efficiency for smarter value investing.',
  },
};

export default meta;
